<div style="touch-action: none; user-select: none; -webkit-user-drag: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0)">
  <slot />
</div>



// WEBPACK FOOTER //
// ./src/components/Touch/src/Touch.html